<div [@toggleBetslipPill]="isBetslipOpen ? 'open' : 'closed'" (click)="onViewBetSlip()" class="betslip-floating">
    <p>Bet Slip <span class="bet-slip-count" *ngIf="betSlipCount > -1">({{ betSlipCount }})</span></p>
</div>
